import { Colors } from "@analyticsMD/quil";
import { css } from "@emotion/css";

export const styles = {
  headerSection: css`
    padding: 1rem;
  `,
  roundedSection: css`
    padding: 1rem 1rem 1rem 1rem;
  `,
  emptyImg: css`
    height: 15rem;
    width: 15rem;
    margin: -3rem 0 -3rem 1rem;
  `,
  emptyMsg: css`
    margin-bottom: 0;
    color: ${Colors.grey_40};
    width: 50%;
    text-align: center;
    font-size: 0.9rem;
  `,
  emptyWrapper: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 2rem;
    margin-bottom: 2rem;
  `,
};

export const sxStyles = {
  sectionHeading: {
    fontSize: "0.875rem",
    fontWeight: "bold",
    display: "flex",
    alignItems: "center",
    color: Colors.grey_65,
  },
  headingWrapper: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "0.5rem",
    marginTop: "0.5rem",
  },
};
